import {
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  styled,
} from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const StyledStepLabel = styled(StepLabel)(() => ({
  '& .Mui-active circle': {
    color: NEW_COLORS.SECONDARY[500],
  },
  '& .Mui-completed path': {
    color: NEW_COLORS.SEMANTICS.SUCCESS[500],
  },
  '& .MuiStepLabel-alternativeLabel .MuiStepLabel-label': {
    marginTop: '8px',
  },
}));

const QontoConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 12px)',
    right: 'calc(50% + 12px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: NEW_COLORS.SEMANTICS.SUCCESS[500],
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: NEW_COLORS.SEMANTICS.SUCCESS[400],
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: NEW_COLORS.GRAYSCALE[300],
    borderTopWidth: 1,
    borderRadius: 1,
  },
}));

export { QontoConnector, StyledStepLabel };
